import {
  IconBrandFacebook,
  IconHome,
  IconInfoCircle,
  IconPhoto,
  IconSparkles,
  IconTag,
} from '@tabler/icons-react';
import logo from './assets/pedi_logo.png';
import heroImage from './assets/home-bg.jpg';
import aboutImage from './assets/about-nail.jpg';
import serviceImage from './assets/services-bg.jpg';
import specialsImage from './assets/specials-bg.jpg';
import gallery1 from './assets/gallery/gallery1.jpg';
import gallery2 from './assets/gallery/gallery2.jpg';
import gallery3 from './assets/gallery/gallery3.jpg';
import gallery4 from './assets/gallery/gallery4.jpg';
import gallery5 from './assets/gallery/gallery5.jpg';
import gallery6 from './assets/gallery/gallery6.jpg';
import gallery7 from './assets/gallery/gallery7.jpg';
import gallery8 from './assets/gallery/gallery8.jpg';
import gallery9 from './assets/gallery/gallery9.jpg';
import gallery10 from './assets/gallery/gallery10.jpg';
import gallery11 from './assets/gallery/gallery11.jpg';
import gallery12 from './assets/gallery/gallery12.jpg';
import gallery13 from './assets/gallery/gallery13.jpg';
import gallery14 from './assets/gallery/gallery14.jpg';
import gallery15 from './assets/gallery/gallery15.jpg';
import gallery16 from './assets/gallery/gallery16.jpg';
import gallery17 from './assets/gallery/gallery17.jpg';
import gallery18 from './assets/gallery/gallery18.jpg';
import gallery19 from './assets/gallery/gallery19.jpg';
import gallery20 from './assets/gallery/gallery20.jpg';
import gallery21 from './assets/gallery/gallery21.jpg';
import gallery22 from './assets/gallery/gallery22.jpg';
import gallery23 from './assets/gallery/gallery23.jpg';
import gallery24 from './assets/gallery/gallery24.jpg';
import gallery25 from './assets/gallery/gallery25.jpg';

export const navigationLinks = [
  { label: 'Home', path: '/', icon: IconHome },
  { label: 'About', path: '/about', icon: IconInfoCircle },
  { label: 'Gallery', path: '/gallery', icon: IconPhoto },
  { label: 'Services', path: '/services', icon: IconSparkles },
  { label: 'Specials', path: '/specials', icon: IconTag },
];

export const salonInfo = {
  name: 'Pedi N. Nails',
  logo,
  phoneDisplay: '(585) 671-2740',
  phoneHref: 'tel:585-671-2740',
  address: '2186 Empire Boulevard, Webster, NY 14580',
  mapHref: 'https://goo.gl/maps/4mRBnnfCaq5zUNYd8',
  facebookHref: 'https://www.facebook.com/PEDI-n-Nails-Webster-108709141728138',
  facebookIcon: IconBrandFacebook,
  tagline: 'Elegant nail care with a warm neighborhood touch.',
};

export const heroContent = {
  logo,
  image: heroImage,
  eyebrow: 'Webster, New York',
  title: 'The premier nail salon for the pampering you deserve.',
  description:
    'Modern manicures, indulgent pedicures, and careful finishing touches for every appointment.',
};

export const aboutContent = {
  image: aboutImage,
  heading: 'About Us',
  paragraphs: [
    'Here at Pedi N. Nails, we strive to offer our clients the best results and customer service possible. With our affordable services, you can enjoy a polished, pampered experience without overdoing the cost.',
    'We offer everything from classic manicures to luxury pedicures, and we are proud to serve Webster with attentive service, quality products, and a welcoming atmosphere.',
  ],
};

export const reviewContent = {
  googleRating: '4.7',
  googleReviewCount: '466',
  googleProfileHref:
    'https://www.google.com/maps/place/Pedi+N+Nails+Webster/@43.2014783,-77.4961466,17z/data=!4m16!1m9!3m8!1s0x89d6c914fd28a71f:0x7e896ffa600fb6f1!2sPedi+N+Nails+Webster!8m2!3d43.2014783!4d-77.4961466!9m1!1b1!16s%2Fg%2F11b73t_7nw!3m5!1s0x89d6c914fd28a71f:0x7e896ffa600fb6f1!8m2!3d43.2014783!4d-77.4961466!16s%2Fg%2F11b73t_7nw?entry=ttu&g_ep=EgoyMDI2MDMyNC4wIKXMDSoASAFQAw%3D%3D',
  heading: "Don't take it from us, read these happy customer reviews!",
  reviews: [
    "Love this place! I don't live in Rochester but I always try to go when I'm in town. Their customer service is awesome...",
    'I highly recommend Pedi N Nails! This was my fist time there for a pedicure. The salon is cheerful and everyone there was very nice, and professional.',
    'I had a lovely experience. The staff was very kind and professional. My nails look amazing and lasted several weeks.',
    'Brian at Pedi and Nail Salon is amazing! He is incredibly skilled and attentive to detail. My nails have never looked better, and the whole experience was so relaxing.',
    "Extremely satisfied with my first service here! Came for my best friends bridal appointment and was blown away, I understand why it's her favorite spot!",
  ],
};

export const servicesContent = {
  image: serviceImage,
  eyebrow: 'Service Menu',
};

export const specialsContent = {
  image: specialsImage,
  title: 'Specials',
  message:
    'We do not have any active specials right now, but we would still love to welcome you in for a relaxing visit. Check back soon for seasonal offers.',
};

export const galleryImages = [
  { src: gallery1, alt: 'Nail salon gallery photo 1' },
  { src: gallery2, alt: 'Nail salon gallery photo 2' },
  { src: gallery3, alt: 'Nail salon gallery photo 3' },
  { src: gallery4, alt: 'Nail salon gallery photo 4' },
  { src: gallery5, alt: 'Nail salon gallery photo 5' },
  { src: gallery6, alt: 'Nail salon gallery photo 6' },
  { src: gallery7, alt: 'Nail salon gallery photo 7' },
  { src: gallery8, alt: 'Nail salon gallery photo 8' },
  { src: gallery9, alt: 'Nail salon gallery photo 9' },
  { src: gallery10, alt: 'Nail salon gallery photo 10' },
  { src: gallery11, alt: 'Nail salon gallery photo 11' },
  { src: gallery12, alt: 'Nail salon gallery photo 12' },
  { src: gallery13, alt: 'Nail salon gallery photo 13' },
  { src: gallery14, alt: 'Nail salon gallery photo 14' },
  { src: gallery15, alt: 'Nail salon gallery photo 15' },
  { src: gallery16, alt: 'Nail salon gallery photo 16' },
  { src: gallery17, alt: 'Nail salon gallery photo 17' },
  { src: gallery18, alt: 'Nail salon gallery photo 18' },
  { src: gallery19, alt: 'Nail salon gallery photo 19' },
  { src: gallery20, alt: 'Nail salon gallery photo 20' },
  { src: gallery21, alt: 'Nail salon gallery photo 21' },
  { src: gallery22, alt: 'Nail salon gallery photo 22' },
  { src: gallery23, alt: 'Nail salon gallery photo 23' },
  { src: gallery24, alt: 'Nail salon gallery photo 24' },
  { src: gallery25, alt: 'Nail salon gallery photo 25' },
];

export const serviceData = {
  Manicures: [
    ['Classic Manicure', '$23'],
    ['Gel Manicure', '$30'],
    ['Gel Fill', '$40'],
    ['Pink & White Fill', '$55'],
    ['Gel Full Set', '$50'],
    ['Pink/White Full Set', '$60'],
    ["Ombre' Full Set", '$60'],
    ['Standard Dipping Powder', '$43'],
    ['Dipping Powder With Tip', '$53'],
    ['Dipping Powder With French', '$53'],
    ['Builder Gel Full Set', '$55'],
    ['Builder Gel Fill', '$45'],
    ['Gel X', '$65'],
  ],
  Pedicures: [
    ['24K Golden Pedicure', '$80'],
    ['Collagen Pedicure', '$70'],
    ['Sparkling Hot Spring Pedicure', '$60'],
    ['Lava Luxe Pedicure', '$55'],
    ['Tippi Collagen', '$50'],
    ['Citrine Lavender Pedicure', '$45'],
    ['Standard Pedicure', '$35'],
    ['Add Gel Polish', '$15'],
  ],
  Waxing: [
    ['Eyebrow Wax', '$12'],
    ['Chin Wax', '$12'],
    ['Lip Wax', '$10'],
    ['Other Wax', 'Ask For Price'],
  ],
  'Additional Services': [
    ['Regular Polish Change', '$20'],
    ['Gel Polish Change', '$30'],
    ['Nails Shape', '$5'],
    ['Chrome Color', '$10'],
    ['Cat-Eyes', '$10'],
    ['Gel Removal', '$10'],
    ['Hard Gel | Acrylic | Dip Removal', '$15'],
    ['Nail Fix', '$5'],
    ['Nail Art', '$5'],
  ],
  'Kids 10 & Under': [
    ['Manicure', '$15'],
    ['Pedicure', '$20'],
    ['Nail Art/Design', '$5'],
  ],
};
